import { Directive } from '@angular/core';

@Directive({ selector: '[uxg-user-profile-panel-content], [uxgUserProfilePanelContent]' })
export class UxgUserProfilePanelContentDirective {
  constructor() {}
}
